export class InstantGameError extends Error {
}
